module.exports = __webpack_public_path__ + "img/5.6cbf5bc9.png";